const roomsData = [
	{
		id: 1,
		languageIds: ['dk'],
		name: 'Start Grundlovsdysten'
	}
];

export { roomsData };
